module.exports = __webpack_public_path__ + "media/audio9.69c6dd71.wav";